import Axios, { AxiosResponse } from "axios";

export function download(url: string, filename: string = ""): void {
  const splitUrl = url.split("/");
  if (!filename) filename = splitUrl[splitUrl.length - 1];

  Axios.get(url, { responseType: "blob" })
    .then((res: AxiosResponse) => {
      const href = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    })
    .catch((e) => console.warn("Unable to download file!", e));
}

export function onScroll(querySelector: string, callback: any = null): void {
  const element = document.querySelector(querySelector);
  if (element)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.onscroll = function () {
      if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.scrollTop > this.scrollHeight - this.offsetHeight - 50 &&
        callback !== null
      )
        callback();
    };
}

export function parseHref(url: string): string {
  return url.replace(/^(?:(.*:)?\/\/)?(.*)/i, (match, schema, nonSchemaUrl) =>
    schema ? match : `http://${nonSchemaUrl}`
  );
}

export function isValidIpUrl(url: string): boolean {
  const urlPattern = new RegExp(
    [
      "^https?://([a-z0-9\\.\\-_%]+:([a-z0-9\\.\\-_%])+?@)?",
      "((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\\.){3}(25[0-5]|2[0-4",
      "][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])?",
      "(:[0-9]+)?(/[^\\s]*)?$",
    ].join(""),
    "i"
  );
  return urlPattern.test(url);
}
export function isValidUrl(url: string): boolean {
  return /(http|https):\/\/(\w+:?\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@\-/]))?/.test(
    url
  );
}
